import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_REPORTS_VERIFICATION_QUERY = gql`
  query pagedReportsVerification($pager: PagerInputNew, $filters: ReportsVerificationFilterInput) {
    pagedReportsVerification(pager: $pager, filters: $filters) {
      total
      values {
        ...reportVerification
      }
    }
  }
  ${Fragments.reportVerification}
`;

export const INTERROGATION_SETTINGS_QUERY = gql`
  query interrogationSettings {
    interrogationSettings {
      id
      service
      interrogatedLastDate
      isActive
      communicationType
      communicationTypeMethod
    }
  }
`;
